import upAndDown from './upAndDown.vue'
export default upAndDown
